import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import HubspotContext from "../../../context/hubspot";
import { env } from "../../../env";

declare global {
  interface Window {
    _hsq: any[];
  }
}

interface HubspotProviderProps {
  children: ReactNode;
}

const identifyHubspotUser = (
  email: string,
  firstName: string,
  lastName: string,
) => {
  const _hsq = (window._hsq = window._hsq || []);
  // naming of properties is important for hubspot, do not change casing
  _hsq.push([
    "identify",
    {
      email,
      ...(firstName && { firstname: firstName }),
      ...(lastName && { lastname: lastName }),
    },
  ]);
  // !! MUST TRACK PAGE VIEW AFTER IDENTIFY !!
  //https://developers.hubspot.com/docs/reference/api/analytics-and-events/tracking-code/v1
  _hsq.push(["trackPageView"]);
};

function HubspotProvider({ children }: HubspotProviderProps) {
  const location = useLocation();

  // <!-- Start of HubSpot Embed Code -->
  // <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/1711513.js"></script>
  // <!-- End of HubSpot Embed Code -->

  useEffect(() => {
    const hubspotScript = document.getElementById("hs-script-loader");
    if (!hubspotScript) {
      const hubspotId = env.HUBSPOT_ID;
      const script = document.createElement("script");
      script.src = `//js.hs-scripts.com/${hubspotId}.js`;
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";
      document.body.appendChild(script);
    }

    return () => {
      const hubspotScript = document.getElementById("hs-script-loader");
      if (hubspotScript) {
        document.body.removeChild(hubspotScript);
      }
    };
  }, []);

  useEffect(() => {
    // Used to trigger page view event in Hubspot
    // https://developers.hubspot.com/docs/reference/api/analytics-and-events/tracking-code
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(["setPath", `${location.pathname}${location.search}`]);
    _hsq.push(["trackPageView"]);
  }, [location]);

  return (
    <HubspotContext.Provider value={{ identifyHubspotUser }}>
      {children}
    </HubspotContext.Provider>
  );
}

export default HubspotProvider;
